import React, { useState } from 'react';
import RankingList from './components/RankingList';
import NominationModal from './components/NominationModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState('flower');
  const [showRules, setShowRules] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <header className="py-10 px-4 text-center bg-white shadow-sm">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-3xl md:text-5xl font-bold text-pink-500 tracking-wide">
            YLCSS Secret
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-600">
            元朗天主教中學 2024-25年度校花校草選舉
          </h2>
          <div className="text-lg text-red-500 font-bold mb-4">
            投票已結束，多謝大家參與
          </div>
          <div className="mb-6">
            <a
              href={`/all-contestants?category=${currentCategory}`}
              className="btn bg-pink-500 hover:bg-pink-600 text-white"
            >
              顯示所有參賽者圖片
            </a>
          </div>
        </div>
      </header>

      <div className="flex justify-center gap-1 my-4">
        <button
          onClick={() => {
            setCurrentCategory('flower');
            setShowRules(false);
          }}
          className={`btn ${currentCategory === 'flower' && !showRules ? 'bg-pink-500 text-white hover:bg-pink-600' : 'btn-ghost text-pink-500'}`}
        >
          校花投票
        </button>
        <button
          onClick={() => {
            setCurrentCategory('grass');
            setShowRules(false);
          }}
          className={`btn ${currentCategory === 'grass' && !showRules ? 'bg-pink-500 text-white hover:bg-pink-600' : 'btn-ghost text-pink-500'}`}
        >
          校草投票
        </button>
        <button
          onClick={() => setShowRules(true)}
          className={`btn ${showRules ? 'bg-pink-500 text-white hover:bg-pink-600' : 'btn-ghost text-pink-500'}`}
        >
          選舉說明
        </button>
      </div>

      <main className="container mx-auto px-2">
        {showRules ? (
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold text-pink-500 mb-4">選舉規則說明</h2>
            <div className="prose">
              <p>2024-25年度校花校草選舉提名及投票期為2024年12月25日至2024年1月1日。同學可以在這段時間提名候選人，並透過網站投票。</p>
              <p>1. 投票方式為從隨機兩位候選人中選出一位您認為較好的，最終系統會通過算法整理出最終排名，每名候選人最初都會有1500分，分數會隨著同學投票選擇而增加/減少。</p>
              <p>2. 同學可以通過下方提名校花/校草</p>
              <p>3. 請勿發布不當內容，不當內容會被刪除</p>
              <div className="bg-pink-50 p-4 rounded-lg mt-4">
                <p className="text-red-500 font-bold mb-2">
                  如果你需要delete，請dm我地
                </p>
                <a 
                  href="https://www.instagram.com/ylcss_secret_org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-sm bg-pink-500 hover:bg-pink-600 text-white"
                >
                  聯絡我地刪除
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid md:grid-cols-1 gap-8">
            <div>
              <RankingList category={currentCategory} />
            </div>
          </div>
        )}
      </main>

      <NominationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default App;
